module.exports = __webpack_public_path__ + "static/media/woman-getting-attractive-cashback.61fad64b.png";